/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';
import Vue from 'vue';

const initialState = () => ({
  messages_current_user: [],
  read_messages_current_user: [],
  messages_projects: {},
  messages_projects_active: {},
  messages_businesses: {},
  messages_twork_packages: {},
  cache: {},
  error: ''
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getMessagesCurrentUser: (state) => state.messages_current_user,
  getReadMessagesCurrentUser: (state) => state.read_messages_current_user,
  getMessagesProject: (state) => (id) => state.messages_projects[id],
  getMessagesProjectWarningActive: (state) => (id) => {
    if(Object.prototype.hasOwnProperty.call(state.messages_projects_active, id)){
      return state.messages_projects_active[id].warnings;
    } else {
      return {};
    }
  },
  getMessagesProjectNotificationActive: (state) => (id) => {
    if(Object.prototype.hasOwnProperty.call(state.messages_projects_active, id)){
      return state.messages_projects_active[id].notifications;
    } else {
      return {};
    }
  },
  getMessagesBusiness: (state) => (id) => state.messages_businesses[id],
  getMessagesTWorkPackage: (state) => (id) => {
    return state.messages_twork_packages[id];
  },
  getWP2: (state) => state.wp_2,
  getCache: (state) => { return state.cache; }
};
// Actions
const actions = {
  requestMessagesCurrentUser({commit, getters}){
    return new Promise((resolve, reject) => {
      if ( getters.getCache['messages?show=showForCallingUser'] && new Date().getTime() < getters.getCache['messages?show=showForCallingUser'].time_expired ) {
        resolve();
      } else {
        axios({
          url: 'messages?show=showForCallingUser',
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(resp => {
          commit('set_messages_current_user', resp.data.data);
          commit('set_cache', 'messages?show=showForCallingUser');
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          reject();
        });
      }
    });
  },
  requestOldMessagesCurrentUser({commit}){
    return new Promise((resolve, reject) => {
      axios({
        url: 'messages/0/readmessages?show=showForCallingUser',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_read_messages_current_user', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  requestMarkMessageAsRead({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'messages/' + payload.message_id +  '/markasread',
        method: 'PUT'
      })
      .then(() => {
        commit('remove_current_user_message', payload);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  requestMessagesProject({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'messages/projects/' + payload.project_id,
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_messages_projects', {
          id: payload.project_id,
          messages: resp.data.data
        });
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  requestMessagesProjectActive({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'messages/projects/' + payload.project_id + '/active?show=showWithEntities',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_messages_projects_active', {
          id: payload.project_id,
          messages: resp.data.data
        });
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  requestMessagesBusiness({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'messages/businesses/' + payload.business_id,
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_messages_businesses', {
          id: payload.business_id,
          messages: resp.data.data
        });
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  requestMessagesTWorkPackage({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'messages/tworkpackages/' + payload.twork_package_id,
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_messages_twork_packages', {
          id: payload.twork_package_id,
          messages: resp.data.data
        });
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  requestSendMessage({commit}, message){
    axios({
      url: 'messages',
      method: 'POST',
      data: message
    })
    .then(resp => {
      if (message.twork_packages) {
        for (let i = 0; i < message.twork_packages.length; i++) {
          commit('push_message_twork_packages', {
            id: message.twork_packages[i].id,
            message: resp.data.data
          });
        }
      }
      if (message.projects) {
        for (let i = 0; i < message.projects.length; i++) {
          commit('push_message_projects', {
            id: message.projects[i].id,
            message: resp.data.data
          });
        }
      }
      if (message.businesses) {
        for (let i = 0; i < message.businesses.length; i++) {
          commit('push_message_businesses', {
            id: message.businesses[i].id,
            message: resp.data.data
          });
        }
      }
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  }
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_error(state, err){
    state.error = err;
  },
  set_cache(state, url) {
    state.cache[url] = {
      time_expired: new Date().getTime() + 600000
    };
  },
  set_messages_current_user(state, messages){
    Vue.set(state, 'messages_current_user', messages);
  },
  set_read_messages_current_user(state, messages){
    Vue.set(state, 'read_messages_current_user', messages);
  },
  set_messages_twork_packages(state, payload){
    Vue.set(state.messages_twork_packages, payload.id, payload.messages);
  },
  set_messages_projects(state, payload){
    Vue.set(state.messages_projects, payload.id, payload.messages);
  },
  set_messages_projects_active(state, payload){
    Vue.set(state.messages_projects_active, payload.id, payload.messages);
  },
  set_messages_businesses(state, payload){
    Vue.set(state.messages_businesses, payload.id, payload.messages);
  },
  remove_current_user_message(state, payload){
    let index = state.messages_current_user.findIndex(msg => msg.id === payload.message_id);
    state.messages_current_user.splice(index, 1);
  },
  push_message_twork_packages(state, payload){
    if (! state.messages_twork_packages[payload.id]) {
      Vue.set(state.messages_twork_packages, payload.id, []);
    }
    state.messages_twork_packages[payload.id].push(payload.message);
  },
  push_message_projects(state, payload){
    if (! state.messages_projects[payload.id]) {
      Vue.set(state.messages_projects, payload.id, []);
    }
    state.messages_projects[payload.id].push(payload.message);
  },
  push_message_businesses(state, payload){
    if (! state.messages_businesses[payload.id]) {
      Vue.set(state.messages_businesses, payload.id, []);
    }
    state.messages_businesses[payload.id].push(payload.message);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
